// src/redux/warehouse/dispatch/slice.ts
import { createSlice } from "@reduxjs/toolkit";
import { fetchWarehouseDispatch, fechCreateDispatch } from "./thunk";

interface FetchDispatchState {
  list: any[];
  count: number;
  loading: boolean; 
  error: string | null;
  createDispatchLoading: boolean;
  createDispatchError: string | null;
}

const initialState: FetchDispatchState = {
  list: [],
  count: 0,
  loading: false,
  error: null,
  createDispatchLoading: false,
  createDispatchError: null,
};

const WarehouseDispatchSlice = createSlice({
  name: "Dispatch",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Dispatch List
      .addCase(fetchWarehouseDispatch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWarehouseDispatch.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.count = action.payload.rowCount;
      })
      .addCase(fetchWarehouseDispatch.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch warehouse dispatch list";
      })

      // Create Dispatch
      .addCase(fechCreateDispatch.pending, (state) => {
        state.createDispatchLoading = true;
        state.createDispatchError = null;
      })
      .addCase(fechCreateDispatch.fulfilled, (state, action) => {
  state.createDispatchLoading = false;
  state.createDispatchError = null;
  if (action.payload?.dispatch_id) {
    state.list.unshift(action.payload);
    state.count += 1;
  }
})

      .addCase(fechCreateDispatch.rejected, (state:any, action:any) => {
        state.createDispatchLoading = false;
        state.createDispatchError =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Failed to create dispatch";
      });
  },
});

export default WarehouseDispatchSlice.reducer;
